/**
 * Row labels and tier badges for the offer comparison table.
 *
 * Some products carry their tier inside the label ("Business Phone Corporate",
 * "Eniq AI Pro"). In a comparison the row must use the generic product name and
 * move the tier into each cell — otherwise the row takes the name of whichever
 * offer happened to come first, and an offer on Standard reads as if it shipped
 * Pro.
 */

export const TIER_PRODUCT_LABELS = {
  'business-phone': 'Business Phone',
  'fmc': 'FMC',
  'eniq-ai': 'Eniq AI',
};

export const TIER_PRODUCTS = new Set(Object.keys(TIER_PRODUCT_LABELS));

const splitLabel = (label) => {
  const match = String(label || '').match(/^(.+?)\s*\((.+)\)$/);
  return {
    name: match ? match[1] : String(label || ''),
    detail: match ? match[2] : null,
  };
};

/** Row label for a product in the comparison table. */
export const getComparisonRowLabel = (type, label) => {
  if (TIER_PRODUCTS.has(type)) return TIER_PRODUCT_LABELS[type];
  return splitLabel(label).name;
};

/** Tier shown inside the cell, or null when the product has no tier. */
export const getComparisonTierName = (type, label) => {
  if (!TIER_PRODUCTS.has(type)) return null;
  return splitLabel(label).name.replace(TIER_PRODUCT_LABELS[type], '').trim() || null;
};
